<div class="score-predictor">


  <!-- Loading State -->
  <div class="loader" *ngIf="loading">
    <app-page-loader></app-page-loader>
  </div>

  <!-- Main Content -->
  <div class="main-content" *ngIf="!loading">
    <!-- Score Cards Section -->

    <div class="header-section">
       <div class="flex align-end">
        <h1>{{courseTitle}}</h1>
        <h6>Predicted for {{currentDate | date:'MMM d, y' }}</h6>
       </div>


        <div>
            <div class="course_filter " *ngIf="courses?.length > 1">
                <span>Course</span>
                <p-dropdown [options]="courses" [(ngModel)]="selectedCourse" optionLabel="courseName" optionValue="courseID" (onChange)="filterByCourse()"></p-dropdown>
            </div>
       
          </div>
    </div>
    <div class="score-cards-section">
     <div class="flex">
        <div class="score-card predicted-score-card">
            <div class="card-header">
              <h3>Predicted Score</h3>
            </div>
            <div class="card-content">
              <div class="main-score">{{ predictedScore }}</div>
              <div class="score-range">
                <span class="range-label">RANGE</span>
                <span class="range-values">{{ scoreRanges[0] }}-{{ scoreRanges[1] }}</span>
              </div>
            </div>
          </div>
    
          <div class="score-card passing-likelihood-card">
            <div class="card-header">
              <h3>Likelihood of passing</h3>
              <i class="pi pi-info-circle info-icon" 
                 pTooltip="{{feedback}}" 
                 tooltipPosition="top" 
                 *ngIf="feedback"
                 style="cursor: pointer; margin-left: 8px; color: #6c757d;"></i>
            </div>
            <div class="card-content">
              <div class="main-percentage">{{ (passingLikelihood) ? passingLikelihood : 0 }}%</div>
            </div>
          </div>
    
     </div>

      
    </div>

    <!-- Practice Exam Results Section -->
    <div class="practice-results-section">
      <div class="section-header" (click)="toggleResultsSection()">
        <h3>Practice exam results ({{ assessmentData?.length || 0 }})</h3>

      </div>
      
      <div class="results-table-wrapper" *ngIf="isResultsExpanded">
        <p-table 
          [value]="assessmentData" 
          [scrollable]="true" 
          scrollHeight="400px"
          styleClass="practice-results-table">
          
          <ng-template pTemplate="header">
            <tr>
              <th class="exam-column">EXAM</th>
              <th class="date-column">DATE</th>
              <th class="result-column">RESULT</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-assessment>
            <tr>
              <td class="exam-column">{{ assessment.name }}</td>
              <td class="date-column">{{ formatDate(assessment.date) }}</td>
              <td class="result-column">
                <span >
                  {{ assessment.threedigitScore }}
                </span>
                
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="3" class="text-center empty-message">
                <div class="empty-state">
                  <i class="pi pi-inbox empty-icon"></i>
                  <h4>No Practice Exams Available</h4>
                  <p>Complete some practice exams to see your score prediction.</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
